import { transport } from 'config/transport';

export function callApiSaveThuMamNon(congDoanId, month, year, body) {
    return transport.post(`/mamnon/${congDoanId}/thuchi/thumamnon/frommamnon`, body, { params: { month, year } });
}
